import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject } from "@angular/core";
import { DomainRegisterDateDTO } from "../../models/shared.model";

export interface AddTrustedDomainDialogData {
    data: DomainRegisterDateDTO;
    isDomain: boolean;
}

@Component({
    selector: 'app-add-trusted-domain-dialog',
    templateUrl: './add-trusted-domain.dialog.html',
})
export class AddTrustedDomainDialog {

    translateParam = {}

    constructor(
        public dialogRef: MatDialogRef<AddTrustedDomainDialog>,
        @Inject(MAT_DIALOG_DATA) public dialogData: AddTrustedDomainDialogData
    ) {
        this.translateParam = {value: dialogData.data.domain_name}
    }

    submit = (): void => {
        this.dialogRef.close(this.dialogData.data);
    }

    onDismiss = (): void => {
        this.dialogRef.close(false);
    }

    isSubmitDisabled() {
        if (!this.dialogData.isDomain)
            return false;

        return this.dialogData.data.company_name == null || this.dialogData.data.company_name == '';
    }
}

